// Injects the Razorpay Checkout script on demand. Idempotent: a second call
// while the first is still loading (or after it has already loaded) does not
// inject a second <script> tag.
//
// Was copy-pasted into both Billing.jsx and Signup.jsx — one place now, so a fix
// (or the plan-picker reusing it) can't accidentally diverge from the other.
let inflight = null;

export function loadRazorpay() {
  if (typeof window !== "undefined" && window.Razorpay) return Promise.resolve(true);
  if (inflight) return inflight;
  inflight = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => { inflight = null; resolve(true); };
    script.onerror = () => { inflight = null; resolve(false); };
    document.body.appendChild(script);
  });
  return inflight;
}
